import { render, staticRenderFns } from "./ParagraphList.vue?vue&type=template&id=59670c08&scoped=true&"
import script from "./ParagraphList.vue?vue&type=script&lang=js&"
export * from "./ParagraphList.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphList.vue?vue&type=style&index=0&id=59670c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59670c08",
  null
  
)

export default component.exports